export default function throttle(callback, wait) {
    let timeoutId = null;
    let lastArgs = null;
    let lastThis = null;
    let previousTime = 0;

    function invoke() {
        previousTime = Date.now();
        timeoutId = null;
        callback.apply(lastThis, lastArgs);
        lastArgs = null;
        lastThis = null;
    }

    return function throttled(...args) {
        const now = Date.now();
        const remaining = wait - (now - previousTime);

        lastArgs = args;
        lastThis = this;

        if (remaining <= 0 || remaining > wait) {
            if (timeoutId) {
                clearTimeout(timeoutId);
                timeoutId = null;
            }

            invoke();
            return;
        }

        if (!timeoutId) {
            timeoutId = setTimeout(invoke, remaining);
        }
    };
}